import React from 'react';
import {WithFormValidation} from 'components/hocs';
import {FormInput} from 'components/formInput';
import {Button} from 'components/button';
import {LoadingIcon} from 'components/loadingIcon';
import {TranslationMixin} from 'mixins/translationMixin';
import {
    WithPasswordTranslations,
    WithCommonTranslations,
} from 'components/hocs/';
import {Captcha} from 'components/captcha';

export const ForgotPasswordForm = WithPasswordTranslations(WithCommonTranslations(
    WithFormValidation(class extends TranslationMixin(React.Component) {
        constructor(props) {
            super(props);

            this.alertRef = React.createRef();

            this.state = {
                alert: {
                    display: false,
                    type: 'default',
                    message: '',
                },
            };

            this.handleInputChange = this.handleInputChange.bind(this);
        }

        handleInputChange(event, callback) {
            const target = event.target;
            const value = target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name;

            this.props.onChange(name, value, function() {
                if (typeof callback === 'function') {
                    callback();
                }
            });
        }


        render(){
            let {formValues, loading, isValidated} = this.props;
            return (
                <div className='col-sm-12 col-md-6 p-0'>
                    <FormInput label={this.getTranslation('LABEL_LOGIN_NAME')}
                               name="username"
                               id="username"
                               minLength={8}
                               maxLength={50}
                               required={true}
                               value={formValues.username}
                               displayError={isValidated}
                               onChange={this.handleInputChange}/>
                    <FormInput label={this.getTranslation('LABEL_EMAIL')}
                               name="email"
                               id="email"
                               type="email"
                               maxLength={100}
                               required={true}
                               autoComplete="email"
                               value={formValues.email}
                               displayError={isValidated}
                               onChange={this.handleInputChange}/>
                    <div className='pb-4'>
                        <Captcha captchaRef={this.props.captchaRef}/>
                    </div>
                    <Button type="submit"
                            variant="primary" disabled={loading}>
                        <LoadingIcon display={loading}/>
                        {this.getTranslation('BUTTON_SEND_EMAIL')}</Button>
                </div>
            )
        }
    })));
